import { motion } from "framer-motion";
import DroneJobCareer from "./DroneJobCareer";
import VendorSection from "./VendorSection";

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.2 },
  },
};

const VendorAndCareer = () => {
  return (
    <section className="bg-slate-50 min-h-fit py-8 sm:py-10 md:py-12 px-4 sm:px-6 font-sans">
      <div className="container mx-auto max-w-7xl">
        <motion.div
          className="grid grid-cols-1 lg:grid-cols-2 gap-12 md:gap-16 items-start"
          variants={containerVariants}
          initial="hidden"
          animate="visible"
        >
          <DroneJobCareer />
          <VendorSection />
        </motion.div>
      </div>
    </section>
  );
};

export default VendorAndCareer;
